import { loadRemote } from '@docplanner/remotejs-runtime';
import { type MaybeRefOrGetter, toValue, watchEffect } from 'vue';

import { CookieService } from '@/plugins/login-flow/services';
import { useLocaleConfig } from '@/providers/locale-config.provider';

interface RemoteApp {
  mount: (id: string) => void;
  unmount: () => void;
}

// These types are used for analytics purposes
enum RemoteUserTypes {
  FACILITY_DOCTOR = 'facility_doctor',
  INDIVIDUAL_DOCTOR = 'individual_doctor',
  FACILITY_ADMIN = 'facility_admin',
}
type RemoteUserType = `${RemoteUserTypes}`;
interface UserIdentity {
  userId: string;
  pmsDoctorId: string;
  userType: RemoteUserType;
  dpDoctorId?: string;
  dpFacilityId?: string;
}

interface DpSpacesHeaderRemoteProps {
  elementId: MaybeRefOrGetter<string>;
  userIdentity?: Partial<UserIdentity>;
}

export function useDpSpacesHeaderRemote(props: DpSpacesHeaderRemoteProps) {
  const localeConfig = useLocaleConfig();

  let remote: RemoteApp | null = null;

  const load = async () => {
    if (remote) {
      remote.unmount();
    }

    remote = await loadRemote<RemoteApp>({
      app: 'integrations-patient-portal-front-app',
      name: 'header',
      expose: 'app',
      options: {
        locale: localeConfig,
        softwareProvider: 'noa-hub',
        authToken: CookieService.GetSessionToken(),
        userIdentity: props.userIdentity,
      },
    });

    remote.mount(toValue(props.elementId));
  };

  const unload = () => {
    if (remote) {
      remote.unmount();
    }

    remote = null;
  };

  watchEffect(() => {
    if (remote) {
      load();
    }
  });

  return {
    load,
    unload,
  };
}
